module.exports = __webpack_public_path__ + "media/modals/img4-9e313a2f.svg";